// extracted by mini-css-extract-plugin
export default {"headerWrapper":"_a3623110","title":"_6dac1a5c","icon":"_dee88357","bodyText":"_db2d28f1","button":"_792a534a","buttonsWrapper":"_9768caa","text":"_77c49201"};